/* eslint-disable default-param-last */
/**
 * @description Reducer sobre as funções do editor de exame realizado
 * @author Diego Sabino Amorim de Araújo
 * @file edicaoExame/editorExameRealizadoReducer.js
 *
 * @license Copyright (c) 2021 SIGEP DIGETI ITEP/RN
 */

import types from 'utils/actionTypes'

const initialState = {
  exameRealizadoEditorDocumento: {
    documento: {
      texto: '',
    },
  },
  processandoEditor: false,
}

const editorExameRealizadoReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PROCESSANDO_EDITOR: {
      return {
        ...state,
        processandoEditor: action.isProcessando,
      }
    }

    case types.SET_EXAME_REALIZADO_EDITOR_DOCUMENTO: {
      return {
        ...state,
        exameRealizadoEditorDocumento: action.exameRealizadoEditorDocumento,
      }
    }

    default: {
      return {
        ...state,
      }
    }
  }
}

export default editorExameRealizadoReducer
